import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import AIAnswerBlock from './components/AIAnswerBlock';
import Process from './components/Process';
import WhyChoose from './components/WhyChoose';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import MidCTA from './components/MidCTA';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="bg-[#0a1628] min-h-screen">
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <AIAnswerBlock />
      <Process />
      <WhyChoose />
      <ServiceAreas />
      <Testimonials />
      <MidCTA />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
